<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      <span class="badge bg-info rounded-pill bx-pull-right font-size-12">
        Estados
      </span>
      Eventos del calendario
    </h5>
    <div class="card-body">
      <div class="row">        
        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'eventosCalendario',
              query: { estado: 1 }
            }"
            title="Pendientes"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-warning bg-gradient"
                :class="pendientes <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="pendientes"
              >
                {{ pendientesFormato }}
              </div>
            </div>
            <div class="text-warning text-truncate w-100">
              Pendientes
            </div>
          </router-link>
        </div>

        <div class="col-4 text-center">
          <router-link
            :to="{
              name: 'eventosCalendario',
              query: { estado: 2 }
            }"
            title="En proceso"
          >
            <div class="avatar mx-auto">
              <div
                class="avatar-title rounded-circle bg-info bg-gradient"
                :class="procesos <= 999 ? 'font-size-20' : 'font-size-16'"
                :title="procesos"
              >
                {{ procesosFormato }}
              </div>
            </div>
            <div class="text-info text-truncate w-100">
              Procesos
            </div>
          </router-link>
        </div>

        <div class="col-4 text-center">
          <router-link
            :to="{ name: 'eventosCalendario' }"
            title="Eventos del calendario"
          >
            <div class="avatar mx-auto">
              <div class="avatar-title rounded-circle bg-primary bg-gradient font-size-24">
                <i class="mdi mdi-calendar-check"></i>
              </div>
            </div>
            <div class="text-truncate w-100">
              Eventos
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventoCalendarioSrv from '@/services/EventoCalendarioSrv.js'

export default {
  name: 'WEventosCalendario',

  data() {
    return {
      pendientes: sessionStorage.getItem('argusblack.weventoscalendario.pendientes') || 0,
      procesos:   sessionStorage.getItem('argusblack.weventoscalendario.procesos')   || 0,
      intervals: {
        actualizacion: null
      }
    }
  },

  created() {
    var self = this

    this.actualizar()
    this.intervals.actualizacion = setInterval(function() {
      self.actualizar()
    }, 60000)
  },

  computed: {
    pendientesFormato: function() {
      return this.pendientes <= 9999 ? this.pendientes : '999+'
    },
    procesosFormato: function() {
      return this.procesos <= 9999 ? this.procesos : '999+'
    }
  },

  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },

  methods: {
    actualizar() {
      var self = this
      let params = { mes_actual: true }
      EventoCalendarioSrv.nEnProceso(params).then(response => {
        self.procesos = response.data
        sessionStorage.setItem('argusblack.weventoscalendario.procesos', self.procesos)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje) : null
        console.log(error)
      })

      EventoCalendarioSrv.nPendientes(params).then(response => {
        self.pendientes = response.data
        sessionStorage.setItem('argusblack.weventoscalendario.pendientes', self.pendientes)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje) : null
        console.log(error)
      })
    }
  }
};
</script>